import * as React from "react";
import { TableOfContentsAnchor } from "./TableOfContentsAnchor";
import { TableOfContentsList } from "./TableOfContentsList";
import { TableOfContentsListItem } from "./TableOfContentsListItem";
import type { TableOfContentsProps } from "./types";

import { Box } from "@twilio-paste/core/box";
import { css, styled } from "@twilio-paste/styling-library";
import { TableOfContentsHeader } from "./TableOfContentsHeading";

const TOCContainer = styled(Box)(() =>
    css({
        gridArea: "toc",
        display: ["none", "none", "none", "block"]
    })
);
const TableOfContents: React.FC<TableOfContentsProps> = ({ headings }) => {
    if (headings == null) {
        return null;
    }

    return (
        <TOCContainer as="nav" aria-label="document outline" data-cy="table-of-contents">
            <TableOfContentsList>
                {headings.map(({ slug, name, depth }) => {
                    const depthLevel = depth.toString();

                    const paddingLeftValue = depthLevel === "3" || depthLevel === "4" ? "space140" : "space90";
                    if (slug === "") {
                        return <TableOfContentsHeader paddingLeft={paddingLeftValue}>{name}</TableOfContentsHeader>;
                    }
                    const headingLink = `#${slug}`;
                    return (
                        <TableOfContentsListItem
                            key={`${name}-${slug}`}
                            depth={depthLevel}
                            activeClass="is-current"
                            to={slug}
                            spy
                            smooth
                            offset={-80}
                            duration={500}
                        >
                            <TableOfContentsAnchor href={headingLink} paddingLeft={paddingLeftValue}>
                                {name}
                            </TableOfContentsAnchor>
                        </TableOfContentsListItem>
                    );
                })}
            </TableOfContentsList>
        </TOCContainer>
    );
};

export { TableOfContents };
